import React from 'react'

const Bot = () => {
  return (
    <svg viewBox="0 0 1441 44" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M1075,9.63496466 C1174.33333,18.3016313 1296.33333,18.2330924 1441,9.42934787 L1441,44 L0,44 L0,9.42934787 C106.128638,19.5664257 218.461971,24.6349647 337,24.6349647 C469,24.6349647 749.604236,-18.7552698 1075,9.63496466 Z"
          fill="white"
        ></path>
      </g>
    </svg>
  )
}

export default Bot
